import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  z-index: 99999999;
  position: absolute;
  background: #d24d57;
  color: white;
  width: 100%;
  text-align: center;
  padding: 20px 0;
  font-size: 18px;
  font-family: sans-serif;

  a {
    text-decoration: underline;
  }
`;

const PreviewBar = () => {
  return (
    <Wrapper>
      This is page is a preview. <a href="/api/exit-preview">Click here</a> to
      exit preview mode.
    </Wrapper>
  );
};

export default PreviewBar;
